import { AddDisciplineSubgroupDTO, DisciplineSubgroupApi, DisciplineSubgroupDTO, EditDisciplineSubgroupDTO, SemesterTypeEnum, StudyYearEnum } from "../Api";
import { getAuthConfiguration } from "./configuration";

const ApiFactory = () => new DisciplineSubgroupApi(getAuthConfiguration());

export const getDisciplineSubgroup = (id: string) => {
    if (!id) {
        return {} as DisciplineSubgroupDTO;
    }
    return ApiFactory().apiDisciplineSubgroupGetDisciplineSubgroupByIdIdGet({ id });
}

export const getDisciplineSubgroups = (groupId: string, namePattern?: string, semester?: SemesterTypeEnum, studyYear?: StudyYearEnum, page: number = 1, pageSize: number = 10) => {
    return ApiFactory().apiDisciplineSubgroupGetAllDisciplineSubgroupsGet({ page, pageSize, namePattern, groupId });
}

export const addDisciplineSubgroup = (addDisciplineSubgroupDTO: AddDisciplineSubgroupDTO) => {
    return ApiFactory().apiDisciplineSubgroupAddDisciplineSubgroupPost({ addDisciplineSubgroupDTO });
}

export const updateDisciplineSubgroup = (id: string, editDisciplineSubgroupDTO: EditDisciplineSubgroupDTO) => { 
    return ApiFactory().apiDisciplineSubgroupUpdateDisciplineSubgroupIdPut({ id, editDisciplineSubgroupDTO });
}

export const deleteDisciplineSubgroup = (id: string) => {
    return ApiFactory().apiDisciplineSubgroupDeleteIdDelete({ id });
}
